module.exports = __webpack_public_path__ + "static/media/broucher1.5d321aa3.pdf";